'use client';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getPerformance } from "firebase/performance";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB7K0PSVGh0ycGvSpQ1aQIamZNyYR05fEs",
  authDomain: "mira-verify-b2020.firebaseapp.com",
  projectId: "mira-verify-b2020",
  storageBucket: "mira-verify-b2020.firebasestorage.app",
  messagingSenderId: "964621909451",
  appId: "1:964621909451:web:1439a8f83ff24bfcf34a4e",
  measurementId: "G-Q3JLQPDF21"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const performance = getPerformance(app);
